import { FunctionComponent } from "react"
import { Button, Col, Row, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import FilterField from "../components/FilterField"
import { Door } from "../data/models.interface"
import { useGetDoorsQuery } from "../hooks/queries/useGetDoorsQuery"
import useSessionStorage from "../hooks/useSessionStorage"
import useSort from "../hooks/useSort"
import { filterProperty } from "../utils/StringUtils"

interface IDoorsPage {}
const DoorsPage: FunctionComponent<IDoorsPage> = () => {
	const navigate = useNavigate()
	const doorsQuery = useGetDoorsQuery()
	const doors = doorsQuery.data?.doors
	// loading layout
	if (!doors) return <LoadingLayout />
	// normal layout
	return (
		<Container>
			<h2 className="text-center mt-4">Doors</h2>
			<DoorsTable doors={doors} />

			<Row>
				<Col xs="auto">
					<BackButton />
				</Col>
				<Col />
				<Col xs="auto">
					<Button variant="success" onClick={() => navigate("/doors/new")}>
						New
					</Button>
				</Col>
			</Row>
		</Container>
	)
}
export default DoorsPage

const LoadingLayout = () => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Doors</h2>
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface IDoorsTable {
	doors: Door[]
}
const DoorsTable = ({ doors }: IDoorsTable) => {
	const navigate = useNavigate()
	const [nameFilter, setNameFilter] = useSessionStorage("doors-name", "")
	const [serialFilter, setSerialFilter] = useSessionStorage("doors-serial-number", "")
	const [doorNumberFilter, setDoorNumberFilter] = useSessionStorage("doors-door-number", "")
	const [accessFilter, setAccessFilter] = useSessionStorage("doors-access", "")
	const { sortBy, sort } = useSort<Door>("name")
	doors = filterProperty(doors, (d) => d.fullName!, nameFilter)
	doors = filterProperty(doors, (d) => d.accessControllerSerialNumber, serialFilter)
	doors = filterProperty(doors, (d) => d.doorNumber + "", doorNumberFilter)
	doors = filterProperty(doors, (d) => d.access, accessFilter)
	doors = sort(doors)
	//
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					<th onClick={() => sortBy("fullName")}>Name</th>
					<th onClick={() => sortBy("accessControllerSerialNumber")}>Access Controller</th>
					<th onClick={() => sortBy("doorNumber")}>Door Number</th>
					<th onClick={() => sortBy("access")}>Access</th>
				</tr>
				<tr>
					<td>
						<FilterField filter={nameFilter} setFilter={setNameFilter} placeholder="Filter Name" />
					</td>
					<td>
						<FilterField filter={serialFilter} setFilter={setSerialFilter} placeholder="Filter Controller" />
					</td>
					<td>
						<FilterField filter={doorNumberFilter} setFilter={setDoorNumberFilter} placeholder="Filter Door Number" />
					</td>
					<td>
						<FilterField filter={accessFilter} setFilter={setAccessFilter} placeholder="Filter Access" />
					</td>
				</tr>
			</thead>
			<tbody>
				{doors?.map((door) => (
					<tr key={door.id} onClick={() => navigate(`/doors/${door.id}`)}>
						<td>{door.fullName}</td>
						<td>{door.accessControllerSerialNumber}</td>
						<td>{door.doorNumber}</td>
						<td>{door.access}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const BackButton = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}
